import { render } from "./TouchPoints.vue?vue&type=template&id=6a14d8c2&scoped=true"
import script from "./TouchPoints.vue?vue&type=script&lang=js"
export * from "./TouchPoints.vue?vue&type=script&lang=js"

import "./TouchPoints.vue?vue&type=style&index=0&id=6a14d8c2&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a14d8c2"]])

export default __exports__